import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Dialog } from '@material-ui/core';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { ClientSchedulerProvider } from 'Context/NewClientSchedulerContext';
import { noop } from 'Helpers/PropTypes';
import SchedulerModalHeader from './SchedulerModalHeader';
import ViewContainer from './ViewContainer';

const styles = theme => ({
  root: {},
  title: {
    display: 'flex',
    padding: 0,
    backgroundColor: theme.palette.facet.primaryBlueMuted,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  closeButton: {
    color: theme.palette.common.white,
    fontSize: 34,
  },
  titleText: {
    color: theme.palette.common.white,
    fontSize: 32,
  },
  legendContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(7, 0),
    '& > div:not(:first-child)': {
      marginLeft: theme.spacing(5),
    },
  },
  legendEntry: {
    ...theme.typography.body1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.palette.facet.primaryGray,
  },
  legendBubble: {
    width: 19,
    height: 19,
    borderRadius: '50%',
    marginRight: theme.spacing(1),
  },
  greenBubble: {
    backgroundColor: theme.palette.facet.accentGreen2,
  },
  blueBubble: {
    backgroundColor: theme.palette.facet.accentBlue11,
  },
  redBubble: {
    backgroundColor: theme.palette.facet.red,
  },
});

const ClientSchedulerModal = ({
  classes,
  className,
  DialogProps,
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Client Scheduler',
    isPageView: true,
  });
  return (
    <ClientSchedulerProvider>
      <Dialog
        {...rootNodeProps}
        test="client-scheduler-modal"
        open
        fullScreen
        className={classNames(className, classes.root)}
        {...DialogProps}
      >
        <SchedulerModalHeader onClose={DialogProps.onClose} />
        <ViewContainer />
      </Dialog>
    </ClientSchedulerProvider>
  );
};

ClientSchedulerModal.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  DialogProps: PropTypes.object,
};

ClientSchedulerModal.defaultProps = {
  className: '',
  DialogProps: {
    onClose: noop,
  },
};

export default withStyles(styles)(ClientSchedulerModal);
